<template>
  <div class="login-information">
    <div class="tip">已验证过的设备</div>
    <el-table :data="tableData" style="width: 100%;margin-bottom:30px;">
      <el-table-column prop="c_t" label="绑定时间"></el-table-column>
      <el-table-column prop="ua_platform" label="设备"></el-table-column>
      <el-table-column prop="ua_browser" label="浏览器"></el-table-column>
      <el-table-column prop="ip" label="操作">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteDevice(scope.row.fingerprint)"
            type="text"
            size="small"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {
      tableData: [],
      showData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0
    };
  },
  methods: {
    getData() {
      _api.personal.getFp().then(res => {
        this.tableData = res.data;
        this.tableData.forEach(i => {
          i.ua_browser = `${i.ua_browser}  ${i.ua_browser_version}`;
        });
      });
    },
    deleteDevice(fingerprint) {
      this.$confirm("确定要删除该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _api.personal.delDevice({ fp: fingerprint }).then(res => {
            if (res.data == true) {
              this.$message({
                message: "设备删除成功",
                type: "success"
              });
              this.getData();
            } else {
              this.$message(res.data);
            }
          });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.login-information {
  margin: 0 22px;
  .tip {
    margin: 10px 0 30px;
  }
  .cell {
    font-size: 14px;
    color: #585f60;
    text-align: center;
  }

  th {
    background-color: #ebeced !important;
  }
}
</style>
